import PeopleTable from "./People";

export default PeopleTable;
